import mixpanel from 'mixpanel-browser'
import { isAnalyticsEnabled } from '../../../modules/main/app/common/cookies-utils'

export const trackEvent = (eventName, properties) => {
    const analyticsEnabled = isAnalyticsEnabled()

    try {
        if (analyticsEnabled && mixpanel?.config && eventName) {
            if (!properties || typeof properties !== 'object' || Object.keys(properties).length === 0) {
                mixpanel.track(eventName)
            } else {
                mixpanel.track(eventName, properties)
            }
        }
    } catch (error) {
        console.warn(`Sending mixpanel event failed. Error: ${error}`)
    }
}
